import { DateRange } from 'react-day-picker';

import { toast } from 'material-react-toastify';

import { hubApi, withAuthHeader } from '@/lib/backend/api';
import { getAuthToken } from '@/lib/firebase/token';
import { coachKeys } from '@/lib/query/keys/coach';
import { prepareDateRange } from '@/pages/Admin/Sessions/utils/utils';
import { SessionHub } from '@addmile/backend-client';
import * as Sentry from '@sentry/react';
import { useQuery } from '@tanstack/react-query';

export const useCoachSessions = (coachIds: string[], dateRange?: DateRange) => {
  return useQuery<SessionHub[]>({
    queryKey: coachKeys.sessions(coachIds, dateRange),
    queryFn: async () => {
      try {
        if (!coachIds.length) return [];
        const token = await getAuthToken();
        const dateRangeString = prepareDateRange(dateRange ?? null);

        const { data: sessions } = await hubApi.getSessionsHub(
          undefined,
          coachIds,
          dateRangeString.from ?? undefined,
          dateRangeString.to ?? undefined,
          withAuthHeader(token),
        );

        return sessions.sessions.filter((session) => session.bookedAt);
      } catch (error) {
        Sentry.captureException(`Failed to fetch sessions: ${error.message}`);
        toast.error(`Failed to fetch sessions: ${error.message}`);
        return [];
      }
    },
    enabled: coachIds.length > 0,
    staleTime: 60 * 1000, // 1 minute
  });
};
